import "./header.css"
import logoSpi from "../../imagens/logos/spiLogo.png"
import { Link } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';


function Header() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <header className="container-fluid p-0 m-0" id="header">
            <nav className="navbar navbar-expand-lg d-flex justify-content-between  p-0 ps-1">
                <div className="LogoImage">
                    <Link to="/">
                        <img src={logoSpi} alt="Logo Spi"></img>
                    </Link>
                </div>
                <Button onClick={handleShow} className="navbar-toggler me-4 mt-2 btn d-lg-none custom-off-canvas-btn"
                    type="button"
                    to="#offcanvasExample"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="offcanvasExample"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <FontAwesomeIcon icon={faBars} />
                </Button>
                <div className="collapse navbar-collapse nav justify-content-end p-0 align-items-center" id="navbarSupportedContent" >
                    <ul className="nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link " to="/AboutUs">About Us</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle button" data-bs-toggle="dropdown" to="/" role="button" aria-expanded="false">Capabilities</Link>
                            <ul className="dropdown-menu">
                                <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/Production">Production Capabilities</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/Engineering">Engineering and product development</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/ToolingAndManufacturing">Toolings design and manufacturing</Link></li>

                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link custom-home" to="/GlobalLocations">Global Locations</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link custom-home" to="/ContactUs">Contact Us</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link custom-home" to="/Certificates">Certificates</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link custom-home" to="/Customers">Customers</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link custom-home" to="/News">News</Link>
                        </li>
                    </ul>
                </div>
                <Offcanvas show={show} onHide={handleClose}>
                    <Offcanvas.Header closeButton>
                        <Offcanvas.Title className="title">Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body className="m-0 p-0">
                        <ul className="nav row">
                            <li className="nav-item pb-1 pt-4">
                                <Link className="nav-link custom-nav-link" to="/">Home</Link>
                            </li>
                            <li className="nav-item pb-1">
                                <Link className="nav-link custom-nav-link" to="/AboutUs">About Us</Link>
                            </li>
                            <li className="nav-item dropdown pb-1">
                                <Link className="nav-link dropdown-toggle button custom-nav-link" data-bs-toggle="dropdown" to="/" role="button" aria-expanded="false">Capabilities</Link>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/Production">Production Capabilities</Link></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/Engineering">Engineering and product development</Link></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><Link className="dropdown-item custom-nav-link" to="/Capabilities/ToolingAndManufacturing">Toolings design and manufacturing</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item pb-1">
                                <Link className="nav-link custom-nav-link" to="/GlobalLocations">Global Locations</Link>
                            </li>
                            <li className="nav-item pb-1">
                                <Link className="nav-link custom-nav-link" to="/ContactUs">Contact Us</Link>
                            </li>
                            <li className="nav-item pb-1">
                                <Link className="nav-link custom-nav-link" to="/Certificates">Certificates</Link>
                            </li>
                            <li className="nav-item pb-1">
                                <Link className="nav-link custom-nav-link" to="/Customers">Customers</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link custom-nav-link" to="/News">News</Link>
                            </li>

                        </ul>
                    </Offcanvas.Body>
                </Offcanvas>
            </nav>
        </header >
    )
}

export default Header